<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_user_CustomerList.add_account')" :paths="[{
        name: this.$t('pages_user_UserCreateAccount.path.1'),
        path: '/user/list'
      }, {
        name: this.$t('pages_user_CustomerList.add_account')
      }]"></g-page-title>
    </template>
    <g-contents>
      <div class="-bg-white" :class="'-pb-12'">
        <validation-observer v-slot="{invalid}" slim>
          <div class="-tile-container" :class="{'mw-800': stepIndex === 1}">
            <div class="-wrapper -border-bottom">
              <g-step
                size=""
                v-model="stepIndex"
                :stepNames="[
                  $t('pages_user_UserCreateAccount.chooseUser'),
                  $t('pages_user_UserCreateAccount.settingAuth')
                ]"
              />
            </div>
            <IDP-user-choose
              v-show="stepIndex === 0"
              @selected="onSelectedIDPUser"/>
            <user-create-account-input-info
              v-if="stepIndex === 1"
              :selected-user-info="IDPUserInfo"
              @change="onChangeUserInfo"/>
          </div>
          <div class="fixed-bot-menu -border-top -width-100  -py-2 -wrapper end- -bg-white">
            <div class="-mr-5" v-if="stepIndex === 0">
              <g-button variant="secondary"  size="large" bg-color="white" id="customer-portal-cancel"   @click="onClickCancel">
                {{$t('common.cancel')}}
              </g-button><!--
              --><g-button
              id="customer-portal-next"
                variant="primary"
                size="large"
                class="-mr-0"
                :disabled="!selectedIDPUser"
                @click="onClickNext">
                {{$t('common.next')}}
              </g-button>
            </div>
            <div class="-mr-5" v-if="stepIndex === 1">
              <g-button variant="secondary"  size="large" bg-color="white" id="customer-portal-prev" @click="onClickPrev">
                {{$t('common.prev')}}
              </g-button><!--
              --><g-button variant="primary" size="large" class="-mr-0" d="customer-portal-create" @click="onClickCreate" :disabled="invalid">
                {{$t('common.create')}}
              </g-button>
            </div>
          </div>
        </validation-observer>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import Vue from 'vue'
import {cloneDeep} from 'loadsh'
import {mapActions, mapGetters} from 'vuex'
import CodeCreate from '../../code/CodeCreate'
import IDPUserChoose from './components/IDPUserChoose.vue'
import UserCreateAccountInputInfo from './components/UserCreateAccountInputInfo.vue'
import {ValidationObserver} from 'vee-validate'
export default {
  name: 'user-create-account',
  components: {
    IDPUserChoose,
    UserCreateAccountInputInfo,
    ValidationObserver
  },
  data () {
    return {
      stepIndex: 0,
      IDPUserInfo: {},
      createUserInfo: {
        auth: '',
        leader: '',
        userName: '',
        dept: '',
        duty: '',
        userEmail: '',
        userTelNo: '',
        customerDeptName:'',
        employeeCode:'',
        deptTeamCode:'',
      }
    }
  },
  computed: {
    ...mapGetters('user', ['codeUserCreate', 'userErrorMessage', 'userInfo']),
    ...mapGetters('customer', ['groupList']),
    selectedIDPUser () {
      if (this.IDPUserInfo && Object.keys(this.IDPUserInfo).length > 0) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('user', ['getIDPUserList', 'getIsUserExists', 'createUser']),
    onSelectedIDPUser (IDPUserInfo) {
      const cloneIDPUserInfo = cloneDeep(IDPUserInfo)
      cloneIDPUserInfo.userTelNo = IDPUserInfo.userTelNo.replaceAll('-', "")
      this.IDPUserInfo = cloneIDPUserInfo;
    },
    onChangeUserInfo (createUserInfo) {
      Vue.set(this, 'createUserInfo', createUserInfo)
    },
    onClickCancel () {
      this.$router.push('/user/list')
    },
    onClickNext () {
      var that = this;
      this.getIsUserExists({userId: this.IDPUserInfo.userEmail}).then(function(exists){
        if(exists){
          that.$showToast(that.$t(`pages_user_UserCreateAccount.existsUser`))
        }else{
          that.stepIndex = 1
        }
      })
    
      
    },
    onClickPrev () {
      this.stepIndex = 0
    },
    onClickCreate () {
        if(!this.createUserInfo.auth){
          this.$showToast(this.$t('pages_user_UserCreateAccount.shouldSettingAuth'))
          return
        }

        if(!this.createUserInfo.customerCode){
          this.$showToast(this.$t('pages_user_UserCreateAccount.shouldSettingCompany'))
          return
        }
        this.createUserInfo.companyCode = this.userInfo.companyCode
        if (this.createUserInfo.userTelNo && this.createUserInfo.userTelNoCtrCd) {
            this.createUserInfo.userTelNo  = this.createUserInfo.userTelNo.replace(this.createUserInfo.userTelNoCtrCd, '').trim();
        }
        this.createUser(this.createUserInfo);


    }
  },
  watch: {
    codeUserCreate () {
      if (this.codeUserCreate === CodeCreate.SUCCESS) {
        this.$showToast(this.$t('pages_user_UserCreateAccount.create_user'))
        this.$router.push('/user/info?userid=' + this.createUserInfo.userEmail)
      } else if (this.codeUserCreate === CodeCreate.ERROR) {
        if (this.$te(`pages_user_UserCreateAccount.${this.userErrorMessage}`)) {
          this.$showToast(this.$t(`pages_user_UserCreateAccount.${this.userErrorMessage}`))
        } else {
          this.$showToast(this.$t(`pages_user_UserCreateAccount.error`))
        }
      }
    }
  },
  beforeMount () {
    
  }
}
</script>

<style scoped>
.mw-1200 {
  max-width:1200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/UserCreate.vue